<div class="modal-header border-b">
    <h4 class="modal-title title">{{modelHeader}}</h4>

    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body margin-td">
    <div class="card scrollbar">
        <div class="card-content">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <div class="af-form-group">
                            <label>{{'lblDate' | translate}}:</label>
                            <div class="lbl-info">
                                {{notificationList.date | date : 'short'}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="af-form-group">
                            <label>{{'lblRegNumber' | translate}}:</label>
                            <div class="flmid">
                                <div class="licplate LPNo d-flex">
                                    <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                    {{notificationList.licensePlateNo}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="af-form-group">
                            <label>{{'lblDealer' | translate}}:</label>
                            <div class="lbl-info">
                                {{notificationList.dealerName}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="af-form-group">
                            <label translate>{{'lblSender' | translate}}:</label>
                            <div class="lbl-info">
                                {{notificationList.fromName}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="af-form-group">
                            <label translate>{{'lblWorkOrderNo' | translate}}:</label>
                            <div class="lbl-info">
                                {{notificationList.workOrderNo}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="af-form-group">
                            <label translate>{{'lblSubject' | translate}}:</label>
                            <div class="lbl-info">
                                {{notificationList.subject}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="af-form-group">
                            <label translate>{{'lblContent' | translate}}:</label>
                            <div class="lbl-info">
                                <div [innerHTML]="notificationList.content" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="activeModal.dismiss(false)"
        translate>lblClose</button>
</div>